import React, { useEffect, useState } from "react";
import Layout from "../../assets/images/crop.png";
import { newFormatDate, setCertificateData } from "../../utils/constants";
import { useNavigate } from "react-router-dom";
import { Award, Download, UserRound } from "lucide-react";
import { modalBody, modalPrimaryBtn, modalSubtitle, modalTitle } from "../ui/modalDesign";

function ProgramsList(programs: any) {
  const [childPrograms, setChildPrograms] = useState<any>({});
  const navigate = useNavigate();

  useEffect(() => {
    setChildPrograms(programs.programs);
  }, [programs]);

  const programsWithCertificate =
    childPrograms?.programs?.filter(
      (each: any) => each?.reports?.[each?.reports?.length - 1]?.cohortCompleted
    ) || [];
  const hasAnyCertificate = programsWithCertificate.length > 0;

  const toggleDownload = (title: any, end: any, status: any) => {
    setCertificateData({
      name: childPrograms.firstName + " " + childPrograms.lastName,
      title,
      date: newFormatDate(end),
      status,
    });
    navigate("/parent/certificate");
  };

  return (
    <div className={`${modalBody} max-h-[85vh] overflow-y-auto`}>
      {childPrograms ? (
        <>
          <div className="mb-5 flex items-center gap-3 rounded-[14px] border border-[#efe6f1] bg-[#FBF8FC] px-4 py-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-ryd-primaryLess1 text-ryd-primary">
              <UserRound size={18} />
            </div>
            <div>
              <p className="text-[12px] font-medium uppercase tracking-wide text-[#94a3b8]">Learner</p>
              <h2 className="font-[AvertaStd-Semibold] text-[16px] text-ryd-headerTextPrimary">
                {childPrograms.firstName} {childPrograms.lastName}
              </h2>
            </div>
          </div>

          <h1 className={modalTitle}>Certificates</h1>
          <p className={`${modalSubtitle} mb-5`}>Download certificates for completed programs.</p>

          {!childPrograms.programs?.length || !hasAnyCertificate ? (
            <div className="rounded-[16px] border border-dashed border-[#e8dce8] bg-[#FBF8FC] px-6 py-12 text-center">
              <Award className="mx-auto mb-3 h-12 w-12 text-[#d4c4de]" />
              <p className="text-[14px] text-[#8b9aab]">No certificate available yet</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
              {childPrograms.programs?.map((each: any, i: any) => (
                <div key={i} className="overflow-hidden rounded-[16px] border border-[#efe6f1] bg-white shadow-sm">
                  <img src={Layout} alt="" className="h-28 w-full object-cover" />
                  <div className="space-y-2 p-4">
                    <h2 className="font-[AvertaStd-Semibold] text-[15px] text-ryd-headerTextPrimary">
                      {each.package.title}
                    </h2>
                    <p className="text-[13px] text-[#8b9aab]">Level {each.package.level}</p>
                    <p className="text-[13px] text-[#8b9aab]">{each.package.weekDuration} weeks</p>
                    {each?.reports?.[each?.reports?.length - 1]?.cohortCompleted && (
                      <button
                        type="button"
                        onClick={() =>
                          toggleDownload(
                            each.package.name,
                            each.endClassDate,
                            each?.reports?.[each?.reports?.length - 1]?.cohortCompleted
                          )
                        }
                        className={`${modalPrimaryBtn} mt-2`}
                      >
                        <Download size={15} /> Download Certificate
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      ) : (
        <p className="py-10 text-center text-[14px] text-[#8b9aab]">Loading…</p>
      )}
    </div>
  );
}

export default ProgramsList;
